import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { DashboardSummaryType } from '@/types/dashboardTypes';

export const getDashboardSummaryApi = (): Promise<ApiResponseType<DashboardSummaryType>> => {
  return authApiService.GET('/dashboard/summary/');
};
